import { Component, Input } from '@angular/core';
import { IconNames } from '@app/shared/enums/icon-names';
import { SalesSummary } from '@sales/models/sales-summary';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-menu-sales-summary',
  templateUrl: './menu-sales-summary.component.html',
  styleUrls: ['./menu-sales-summary.component.scss'],
  imports: [MatIcon],
})
export class MenuSalesSummaryComponent {
  IconNames = IconNames;
  @Input() salesSummary: SalesSummary;
}
